class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector("[data-slider]");
    this.slider = null;

    window.addEventListener(
      "resize",
      debounce(this.initSlider.bind(this), 100),
    );
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    const sliderElement = this.querySelector(".announcement-bar__inner");

    if (!sliderElement) return;

    if (
      window.innerWidth >= 990 &&
      sliderElement.hasAttribute("data-slider-destroy-desktop")
    ) {
      sliderElement.classList.add("is-initialized");
      return;
    }

    if (this.slider !== null) return;

    this.slider = new Swiper(sliderElement, {
      direction: "horizontal",
      loop: true,
      autoplay: {
        delay: Number(this.sliderElement.dataset.interval),
        disableOnInteraction: false,
      },
      simulateTouch: false,
    });
  }
}

customElements.define("announcement-bar", AnnouncementBar);
